import { render, staticRenderFns } from "./OnboardingPrivacy.vue?vue&type=template&id=465b42fa&"
import script from "./OnboardingPrivacy.vue?vue&type=script&lang=js&"
export * from "./OnboardingPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports